import React from "react";
import { useRouteMatch, Switch, Route } from "react-router-dom";
import { EditField } from "../components/EditField";
import { EditZone } from "../components/EditZone";
import { ImportFields } from "../components/import/ImportFields";
import { SelectField } from "../components/SelectField";
import { ShowFields } from "../components/show/ShowFields";

export const FieldRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/new`}>
                <EditField />
            </Route>
            <Route path={`${path}/:field/newzone`}>
                <EditZone />
            </Route>
            <Route path={`${path}/select`}>
                <SelectField />
            </Route>
            <Route path={`${path}/import`}>
                <ImportFields />
            </Route>
            <Route path={`${path}/:field/edit`}>
                <EditField />
            </Route>
            <Route path={`${path}/:field/:zone/editzone`}>
                <EditZone />
            </Route>
            <Route path={`${path}/:field`}>
                <ShowFields />
            </Route>
            <Route path={`${path}`}>
                <ShowFields />
            </Route>
        </Switch>
    );
}
